
import {env} from '../../config/env';

export const API_DOMAIN = env.API_ENDPOINT_URL || '';
export const API_BASE_URL = `${API_DOMAIN}/careadmin/hc-app-middleware`;
export const API_KEY = env.API_ENDPOINT_KEY || '';

export const getHealthTrackerRole = () => {
  return "family" as "staff" | "family" | null;
};
